module.exports = __webpack_public_path__ + "media/images/wedding/28-fcfa96ad4d02572b309123f84007d1cf.jpg";